// import { ElButton, ElSelect, ElMessage } from "element-plus";
import elementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/es/locale/lang/zh-cn";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(elementPlus, {
    locale: zhCn,
  });
  //   nuxtApp.vueApp.component(ElButton.name, ElButton);
  //   nuxtApp.vueApp.component(ElSelect.name, ElSelect);
});
